import Card from "@/shared/data-display/card";
import { Result } from "@/shared/feedback/result";
import { isStaleBuildError } from "@/application/stale-build/is-stale-build-error";
import { reloadOnce } from "@/application/stale-build/reload-once";

export function RouteErrorFallback({ error }: { error: Error | null }) {
  if (isStaleBuildError(error) && reloadOnce()) {
    return null;
  }

  return (
    <Card data-testid="route-error">
      <Result status="error" title={error?.name} subTitle={error?.message} />
    </Card>
  );
}
